export const FETCH_SUCCESS = "PERMISSIONS/FETCH_SUCCESS";
export const TABLE_UPDATE = "PERMISSIONS/TABLE_UPDATE";

const types = {
    DESTROY_FAILED: "PERMISSIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "PERMISSIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "PERMISSIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "PERMISSIONS/FETCH_FAILED",
    FETCH_REQUEST: "PERMISSIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    FETCH_ALL_FAILED: "PERMISSIONS/FETCH_ALL_FAILED",
    FETCH_ALL_REQUEST: "PERMISSIONS/FETCH_ALL_REQUEST",
    FETCH_ALL_SUCCESS: "PERMISSIONS/FETCH_ALL_SUCCESS",

    GET_FAILED: "PERMISSIONS/GET_FAILED",
    GET_REQUEST: "PERMISSIONS/GET_REQUEST",
    GET_SUCCESS: "PERMISSIONS/GET_SUCCESS",

    STORE_FAILED: "PERMISSIONS/STORE_FAILED",
    STORE_REQUEST: "PERMISSIONS/STORE_REQUEST",
    STORE_SUCCESS: "PERMISSIONS/STORE_SUCCESS",

    UPDATE_FAILED: "PERMISSIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "PERMISSIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "PERMISSIONS/UPDATE_SUCCESS",

    TABLE_UPDATE,
};

export default types;
